// src/services/api-dtime/api_incorporate_docket_doc_category.js
// ⭐ API แยกต่างหากสำหรับ Document Category ของ Docket (multi-select)
// หมายเหตุ: endpoint นี้ mount แยกเป็น sibling ต่างหากใน routes.js
// (ไม่ได้ซ้อนอยู่ใต้ "/incorporate" เหมือนกลุ่ม incorporate อื่น ๆ)
// ดู server.INCORPORATE_DOCKET_DOC_CATEGORY ใน constants.js
//
// ไม่มี replace-all endpoint (ต่างจาก Change Tracker) — ฝั่ง frontend
// ต้อง loop เรียก createIncorporateDocketDocCategory() ทีละตัวเอง
// ตอนกด Save จากหน้า Docket Add

import httpClientInCorporate from "@/services/httpClientInCorporate";
import { server } from "@/services/constants";

/**
 * ดึง Document Category ทั้งหมดของ docket หนึ่งใบ
 * @param {number|string} docket_id
 */
export const getIncorporateDocketDocCategoryByDocketId = (docket_id) => {
    return httpClientInCorporate.get(
        `${server.INCORPORATE_DOCKET_DOC_CATEGORY}/${docket_id}`,
    );
};

/**
 * เพิ่ม Document Category 1 รายการให้ docket
 * @param {Object} data { docket_id, doc_category, user_create }
 */
export const createIncorporateDocketDocCategory = (data) => {
    return httpClientInCorporate.post(
        `${server.INCORPORATE_DOCKET_DOC_CATEGORY}`,
        data,
    );
};

/**
 * แก้ไข Document Category 1 รายการ (ตาม id ของแถว)
 * @param {number|string} id
 * @param {Object} data { doc_category }
 */
export const updateIncorporateDocketDocCategory = (id, data) => {
    return httpClientInCorporate.put(
        `${server.INCORPORATE_DOCKET_DOC_CATEGORY}/${id}`,
        data,
    );
};

/**
 * ลบ Document Category 1 รายการ (ตาม id ของแถว)
 * @param {number|string} id
 */
export const deleteIncorporateDocketDocCategory = (id) => {
    return httpClientInCorporate.delete(
        `${server.INCORPORATE_DOCKET_DOC_CATEGORY}/${id}`,
    );
};